import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

const useCollectionsCardsKpisData = (start_date, end_date) => {
  const { getCollectionsCardsKpisData } = useApi();
  const { data, isLoading } = useQuery({
    queryKey: ["collectionsCardsKpisData", start_date, end_date],
    queryFn: () => getCollectionsCardsKpisData({ start_date, end_date }),
  });
  return { data: data?.data, isLoading };
};

export default useCollectionsCardsKpisData;
